import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Alert from '~/Common-Objects/UI/Alert'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import LandingPageTemplate from '../template'
const kbArticle =
    'https://transpond.io/support/account-and-user-management/managing-your-profile-and-security#two-factor-authentication-2fa'

export default function Soft2faTrigger() {
    const dispatch = useDispatch()
    const site = useSelector((state) => state.siteMaster)
    useEffect(() => {
        dispatch({ type: 'LOGGEDIN_FAILED', payload: '' })
    }, [])
    return (
        <LandingPageTemplate
            paperClasses='landing-soft2fa'
            header='Login verification required'
            subheader={
                <div>
                    This is the first time we have detected you have logged in from this browser.{' '}
                    <strong>Check your email</strong> and click the link to verify your login.
                </div>
            }
        >
            <Alert
                type={'info'}
                header={'Protect your account with two-factor authentication'}
                content={
                    'You can prevent these verifications by enabling two-factor authentication for faster logins and stronger account protection.'
                }
                cta={
                    <a
                        style={{ textDecoration: 'none', alignItems: 'center' }}
                        className='quickFlex'
                        href={kbArticle}
                        target='_blank'
                    >
                        <div>Learn More</div>
                        <Icons icon='arrowRight' className='quickFlex' style={{ alignItems: 'center' }} />
                    </a>
                }
            />
        </LandingPageTemplate>
        // <div style={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        //     <Paper className="with_header" style={{ margin: '0 64px' }}>
        //         <div className="paper_header" style={{ backgroundColor: site.colours["$primary"], color: 'white' }}>
        //             Login Verification Required
        //         </div>
        //         <div className="paper_content">
        //             <p>This is the first time we have detected you have logged in from this browser, <strong>please check your email</strong> and click the link in our email to verify your login.</p>
        //             <p>Once you’ve logged in using the verification link, to prevent this happening again you can setup 2FA to secure your account by following <a href={kbArticle}>these instructions</a>.</p>
        //         </div>
        //     </Paper>
        // </div>
    )
}
